import { useOne } from 'admin';
import type { Inspection } from 'api';
import { useEffect, useState } from 'react';
import { Box, CenteredLoader, Grid } from 'ui';

import { DealAutocomplete, DealDetails } from '~/deal';
import { DealLoads, InspectionLoadAssigner } from '~/inspection-load';

import { InspectionMutate } from '../InspectionMutate/InspectionMutate';

export const InspectionDetails = ({ inspectionId }: { inspectionId?: number }) => {
  const [currentDeal, setCurrentDeal] = useState<number | undefined>(undefined);

  const { data: inspection, isFetching } = useOne<Inspection>({
    dataProviderName: 'inspections',
    id: inspectionId,
    queryOptions: {
      enabled: !!inspectionId,
    },
    resource: '/v1',
  });

  useEffect(() => {
    if (inspection?.data.deal) {
      setCurrentDeal(inspection?.data.deal);
    }
  }, [inspection]);

  if (isFetching) {
    return <CenteredLoader />;
  }

  if (inspectionId && !inspection) {
    throw new Error('Inspection not found');
  }

  return (
    <Grid container>
      <Grid item sm={4}>
        <Box p={2}>
          <InspectionMutate
            inspection={inspection ? inspection.data : undefined}
            dealId={currentDeal}
            variant={inspectionId ? 'update' : 'create'}
          />
        </Box>
      </Grid>
      <Grid item sm={8}>
        <Box pt={2} px={2}>
          <Box mb={2}>
            {!inspection?.data.deal && (
              <DealAutocomplete
                required
                defaultValue={currentDeal}
                onSelectDeal={(deal) => {
                  setCurrentDeal(deal?.id);
                }}
              />
            )}
          </Box>

          {currentDeal ? (
            <Grid container spacing={2}>
              <Grid item sm={8}>
                <DealDetails dealId={currentDeal} />
              </Grid>
              <Grid item sm={4}>
                {inspection?.data.deal ? (
                  <InspectionLoadAssigner
                    inspectionId={inspection?.data.id}
                    inspectionSlug={inspection?.data.slug}
                    dealId={inspection.data.deal}
                  />
                ) : (
                  <DealLoads dealId={currentDeal} />
                )}
              </Grid>
            </Grid>
          ) : null}
        </Box>
      </Grid>
    </Grid>
  );
};
